import { RequestType } from '@foundation-player/runtime';

export { RequestType };

export type RequestHeader = Record<string, string>;

/**
 * Define an async callback function which will return a header object for arbitrary request types.
 * The function MUST at least return an empty object.
 *
 * The function is also blocking and WILL delay playback.
 */
export type RequestHeaderCallback<T = RequestType> = (
  requestType: RequestType & T,
) => RequestHeader | Promise<RequestHeader>;

/**
 * @internal
 * @param request
 * @param headers
 */
export async function addHeadersToRequest(
  request: { headers?: RequestHeader | object },
  headers: Promise<RequestHeader | undefined>,
): Promise<void> {
  const headerResult = (await headers) || {};
  Object.entries(headerResult).forEach(([key, value]) => {
    request.headers = { ...request.headers, [key]: value };
  });
}
